import { render, staticRenderFns } from "./CustomerDashboardRestrict.vue?vue&type=template&id=6c4b3ad0"
import script from "./CustomerDashboardRestrict.vue?vue&type=script&lang=ts"
export * from "./CustomerDashboardRestrict.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports